import { Lock } from "lucide-react";

const METHODS = [
  { id: "visa", label: "Visa", w: 34 },
  { id: "mastercard", label: "Mastercard", w: 34 },
  { id: "americanexpress", label: "American Express", w: 34 },
  { id: "applepay", label: "Apple Pay", w: 36 },
  { id: "googlepay", label: "Google Pay", w: 36 },
  { id: "paypal", label: "PayPal", w: 22 },
  { id: "klarna", label: "Klarna", bg: "#FFB3C7", w: 22 },
  { id: "sepa", label: "SEPA Addebito diretto", w: 36 },
];

export const PaymentBadges = () => (
  <div className="space-y-2" data-testid="payment-methods">
    <p className="text-xs text-white/60 flex items-center gap-1.5"><Lock className="h-3.5 w-3.5 text-brand-light" />Pagamenti sicuri gestiti da <span className="font-bold text-white/80 tracking-tight">Stripe</span></p>
    <ul className="flex flex-wrap gap-2" aria-label="Metodi di pagamento accettati">
      {METHODS.map(m => (
        <li key={m.id} title={m.label} className="h-8 w-12 rounded-md flex items-center justify-center" style={{ background: m.bg || "#fff" }} data-testid={`pay-${m.id}`}>
          <img src={`/payments/${m.id}.svg`} alt={m.label} style={{ width: m.w, height: 22 }} className="object-contain" loading="lazy" />
        </li>
      ))}
    </ul>
  </div>
);
